import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { getQueryClient } from "./getQueryClient";
import NotFoundPage from "./components/NotFoundPage";
import { routeTree } from "./routeTree.gen";
import ErrorPage from "./components/ErrorPage";
import * as Sentry from "@sentry/tanstackstart-react";
import { getEnv } from "./lib/env";

export function getRouter() {
  const queryClient = getQueryClient();
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    defaultNotFoundComponent: NotFoundPage,
    defaultOnCatch(error) {
      Sentry.captureException(error);
    },
    defaultErrorComponent: ErrorPage,
    context: {
      queryClient,
    },
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  return router;
}
// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

const SENTRY_DSN = getEnv.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,

    // Add optional integrations for additional features
    // integrations: [Sentry.replayIntegration()],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    // replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    // replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  });
}
